<div mat-dialog-title>{{dialogTitle}}<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>

  @if (showInformaErrorMessages && !isUiTest) {
    <mat-card class="error block">
      <mat-card-title class="error">
        Some of the model's data cannot be read by Model Market Center. Please correct these fields in Informa PSN and re-import your PSN ID.
        <p style="margin-bottom: 0;">
        Note: Updates made in Informa PSN before 11:59pm ET will not appear in Model Market Center until the next calendar day.</p>
      </mat-card-title>
    </mat-card>

    <div class="block">
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'300px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptionsInformaErrors"
        [frameworkComponents] = {}
        [rowData] = "informaErrorsData"
      (gridReady)="onGridReadyInformaErrors($event)"></irb-inventory-grid>
    </div>
  }


  @if (showUnrecognizedGrid && !isUiTest) {
    <div style="display: flex; flex-basis: 100%;" class="block">
      <div style="vertical-align: top; width: 120px; padding: 10px 0;font-weight: bold">Models with unrecognized securities:</div>
      <div style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
        @for (model of data.unrecognized.Models; track data.unrecognized?.Models;) {
          <div>{{model}}</div>
        }
      </div>
    </div>

    <div class="block">(These securities are not available in Schwab's security master.)</div>
    <div class="block">
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'200px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptionsUnrecognized"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = 'data.unrecognized.Securities'
      (gridReady) = "onGridReadyUnrecognized($event)"></irb-inventory-grid>

    </div>
    <span>Models with unrecognized securities won't be imported.</span>
  }

  @if (showContainsGrid && !isUiTest) {
    <mat-card class="warn block">
      <mat-card-title class="warn">{{data.noninventoried.Models?.length}} model
        contains {{data.noninventoried.Securities?.length}} securities that aren't in iRebal.
      </mat-card-title>
    </mat-card>

    <div style="display: flex; flex-basis: 100%;" class="block">
      <div style="vertical-align: top; width: 100px; padding: 10px 0;font-weight: bold">Models:</div>
      <div style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
        @for (model of data.noninventoried.Models; track data.noninventoried?.Models;) {
          <div>{{model}}</div>
        }
      </div>
    </div>

    <div class="block">The models above contain securities that are in Schwab's security master, but are NOT in iRebal. Those
      securities (below) will be added to iRebal automatically when you continue. You can choose to assign each to a
      custom category.
    </div>
    <div class="block">
      <irb-inventory-grid
        [style.width]="'100%'"
        [style.height]="'200px'"
        [showSideBar]="false"
        [gridOptions]="gridOptionsContains"
        [frameworkComponents]='frameworkComponents'
        [rowData]='data.noninventoried.Securities'
      (gridReady)="onGridReadyContains($event)"></irb-inventory-grid>
    </div>
    <span>When you continue, the models will be imported and the securities added to the iRebal master</span>
  }

  @if (showFinish && !isUiTest) {
    <!--        <div class="block">-->
    <!--            {{data.modelsToAdd?.length}} models of {{data.validatedModels?.length}} in your file will be added to or overwritten in iRebal.-->
  <!--        </div>-->
  <div>
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'240px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptionsFinish"
      [frameworkComponents] = {}
      [rowData] = "data.validatedModels"
    (gridReady) = "onGridReadyFinish($event)"></irb-inventory-grid>
  </div>
}

</mat-dialog-content>
<mat-dialog-actions>
  @if (showInformaErrorMessages) {
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
    <button id="continueButton" (click)="copyToClipboard()" class="btn-medium-secondary">Copy to Clipboard</button>
    <button id="continueButton" (click)="continueActionAfterInformaErrors()" class="btn-medium-primary">Continue</button>
  } @else {
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
    @if (!showFinish) {
      <button id="continueButton" (click)="continueAction()" class="btn-medium-primary">Continue</button>
    }
    @if (showFinish) {
      <button id="finishButton" (click)="completeImport()" [disabled]="!(data.validRows?.length > 0)" class="btn-medium-primary">Finish</button>
    }
  }
</mat-dialog-actions>
